<app-preloader *ngIf="clientsService.isLoading()"></app-preloader>
<div class="modal">
  <a class="close" (click)="close()">Cerrar</a>
  <h1>
    @if(formStep() === STEP_ENUM.STEP_RFC_SEARCH){ Buscar RFC }
    @else if(formStep() === STEP_ENUM.STEP_EXISTING_CLIENT){ Editar cliente }
    @else if(formStep() === STEP_ENUM.STEP_NEW_READONLY_CLIENT){ Cliente encontrado }
    @else { Nuevo cliente }
  </h1>

  <div class="formCliente">
    <form [formGroup]="formCustomer">
      <div class="wrapperG2">
        <div [ngClass]="{ controlWrapper: !hasOriginalClient, wrapper: hasOriginalClient }">
          @if(formStep() === STEP_ENUM.STEP_RFC_SEARCH) {
          <label for="clientRfc">RFC <span class="required">*</span></label>
          <input type="text" formControlName="rfc" id="clientRfc" (blur)="changeRfc($event)" />
          <span class="error rfc" [style.opacity]="rfcErrorMessages() ? 1 : 0">{{ rfcErrorMessages() }}</span>
          } @else {
          <div class="readonly">
            <label for="clientRfc">RFC</label>
            <span class="value">
              {{ originalClient()?.rfc ?? formCustomer.get('rfc')?.value }}
            </span>
          </div>
          }
        </div>
        @if(formStep() !== STEP_ENUM.STEP_RFC_SEARCH) {
        <div class="wrapper">
          <div class="readonly">
            <label for="clientPersonType">Tipo de persona</label>
            <span class="value">
              {{ clientsService.getPersonType(formPersonType) }}
            </span>
          </div>
        </div>
        } @if(formStep() !== STEP_ENUM.STEP_RFC_SEARCH) {
        <!-- Si es persona física -->
        @if (isNaturalPerson()) {
        @if(formStep() === STEP_ENUM.STEP_NEW_READONLY_CLIENT){
        <div class="readonly">
          <label for="clientLastName">Apellido paterno</label>
          <span class="value">
            {{ originalClient()?.lastName }}
          </span>
        </div>
        } @else {
        <div class="controlWrapper">
          <label for="clientLastName">Apellido paterno <span class="required">*</span></label>
          <input type="text" formControlName="lastName" id="clientLastName"
            (keydown)="allowOnlyLettersAndNumbers($event)" (input)="cleanNaturalPersonInput($event)"
            (paste)="onPasteNaturalPerson($event)" />
        </div>
        }
        @if(formStep() === STEP_ENUM.STEP_NEW_READONLY_CLIENT){
        <div class="readonly">
          <label for="clientMothersLastName">Apellido materno</label>
          <span class="value">
            {{ originalClient()?.mothersLastName }}
          </span>
        </div>
        } @else {
        <div class="controlWrapper">
          <label for="clientMothersLastName">Apellido materno</label>
          <input type="text" formControlName="mothersLastName" id="clientMothersLastName"
            (keydown)="allowOnlyLettersAndNumbers($event)" (input)="cleanNaturalPersonInput($event)"
            (paste)="onPasteNaturalPerson($event)" />
        </div>
        }
        @if(formStep() === STEP_ENUM.STEP_NEW_READONLY_CLIENT){
        <div class="readonly">
          <label for="clientName">Nombre</label>
          <span class="value">
            {{ originalClient()?.firstName || originalClient()?.customerName }}
          </span>
        </div>
        } @else {
        <div class="controlWrapper">
          <label for="clientName">Nombre <span class="required">*</span></label>
          <input type="text" formControlName="firstName" id="clientName" (keydown)="allowOnlyLettersAndNumbers($event)"
            (input)="cleanNaturalPersonInput($event)" (paste)="onPasteNaturalPerson($event)" />
        </div>
        }
        } @else if(isLegalPerson()) {
        <!-- Si es persona moral -->
        @if(formStep() === STEP_ENUM.STEP_NEW_READONLY_CLIENT){
        <div class="readonly">
          <label for="clientNameLegal">Nombre</label>
          <span class="value">
            {{ originalClient()?.customerName }}
          </span>
        </div>
        } @else {
        <div class="controlWrapper">
          <label for="clientNameLegal">Nombre <span class="required">*</span></label>
          <input type="text" formControlName="customerName" id="clientNameLegal"
            (keydown)="allowAlphabeticCharacter($event)" />
        </div>
        } } } @if(viewAceptedCheck()){
        <div class="controlWrapper">
          <label class="checkboxWrapper" for="acceptedErrors">
            <input type="checkbox" id="acceptedErrors" formControlName="acceptedErrors" />
            <span class="checkmark"></span>
            <span class="description">Acepto que el RFC ingresado es correcto</span>
          </label>
        </div>
        }
      </div>
      <!-- Acciones para modal condición -->
      <div class="actions">
        <div class="wrapper">
          <button type="submit" class="primary" (click)="save()" [disabled]="isDisabledForm()">
            @if(formStep() === STEP_ENUM.STEP_NEW_CLIENT){ Crear y seleccionar }
            @else if(formStep() === STEP_ENUM.STEP_RFC_SEARCH){ Continuar }
            @else if(formStep() === STEP_ENUM.STEP_NEW_READONLY_CLIENT){ Seleccionar }
            @else if(formStep() === STEP_ENUM.STEP_EXISTING_CLIENT){ Actualizar y seleccionar }
          </button>
          <button type="button" class="secondary" (click)="cancelModal()">Cancelar</button>
        </div>
      </div>
    </form>
  </div>
</div>
